import { styled } from '@mui/material/styles';
import { Box, SpeedDial, SpeedDialAction } from '@mui/material';
import LoadingButton from "@mui/lab/LoadingButton";

export const LoadingBox = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});

export const LessonEditorContentBox = styled(Box)({
  width: "100%",
  height: "100%",
  flex: 1,
  margin: 0,
  padding: 0
});

export const ActionButtonsBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'openSpeedDial'
})<{ openSpeedDial?: boolean }>(({ openSpeedDial }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  position: "absolute",
  bottom: "30px",
  right: "30px",
  zIndex: 1201, // drawer z-index is 1200
  height: openSpeedDial ? "auto" : "0px"
}));

export const StyledSpeedDial = styled(SpeedDial)({
  zIndex: 1201,
  position: 'relative'
});

export const StyledSpeedDialAction = styled(SpeedDialAction)({
  zIndex: 1201
});

export const FormLoadingButton = styled(LoadingButton)(() => ({
    borderRadius: "19px",
    fontSize: "0.875rem",
    height: "38px",
    lineHeight: "2.0",
    margin: "0 8px",
    padding: "6px 24px",
    textTransform: "none"
}));

export const EditorContainerBox = styled(Box)(({theme}) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 48,
    bottom: 0,
    overflow: 'hidden'
}));